import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Marketplace from './components/Marketplace';
import Rankings from './components/Rankings';
import RulesPage from './components/RulesPage';
import Profile from './components/Profile';
import Deposit from './components/Deposit';
import Tournaments from './components/Tournaments';
import TournamentEntry from './components/tournaments/TournamentEntry';
import TournamentFormation from './components/tournaments/TournamentFormation';
import Register from './components/auth/Register';
import Login from './components/auth/Login';
import ForgotPassword from './components/auth/ForgotPassword';
import Tutorial from './components/onboarding/Tutorial';
import LanguageSelection from './components/onboarding/LanguageSelection';
import PackOpening from './components/onboarding/PackOpening';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminUsers from './components/admin/AdminUsers';
import AdminUserDetail from './components/admin/AdminUserDetail';
import AdminGameWeeks from './components/admin/AdminGameWeeks';
import AdminGameWeekDetail from './components/admin/AdminGameWeekDetail';
import AdminTournamentDetail from './components/admin/AdminTournamentDetail';
import AdminAdmins from './components/admin/AdminAdmins';
import AdminSettings from './components/admin/AdminSettings';
import AdminSettingsPlayers from './components/admin/AdminSettingsPlayers';
import AdminPaypalDeposits from './components/admin/AdminPaypalDeposits';
import AdminScores from './components/admin/AdminScores';
import AdminMonthlyRankings from './components/admin/AdminMonthlyRankings';
import AdminMondiali from './components/admin/AdminMondiali';
import AdminSecondaryMarket from './components/admin/AdminSecondaryMarket';
import AdminEconomy from './components/admin/AdminEconomy';
import AdminMarketplace from './components/admin/AdminMarketplace';
import AdminAffiliations from './components/admin/AdminAffiliations';
import AdminWithdrawals from './components/admin/AdminWithdrawals';
import AdminPromoCode from './components/admin/AdminPromoCode';
import AdminLogs from './components/admin/AdminLogs';
import AdminCards from './components/admin/AdminCards';
import AdminCoachCards from './components/admin/AdminCoachCards';
import AdminPacks from './components/admin/AdminPacks';
import AdminSecurityReports from './components/admin/AdminSecurityReports';
import AdminCommunications from './components/admin/AdminCommunications';
import AdminPlatformEmail from './components/admin/AdminPlatformEmail';
import SupportWidget from './components/SupportWidget';
import CookieBanner from './components/CookieBanner';
import CookiePreferencesModal from './components/CookiePreferencesModal';
import GlobalFooter from './components/GlobalFooter';
import { WalletProvider } from './context/WalletContext';
import { SoundProvider } from './context/SoundContext';
import { MusicProvider } from './context/MusicContext';
import { CookieConsentProvider } from './context/CookieConsentContext';
import OnboardingGuard from './components/OnboardingGuard';
import ErrorBoundary from './components/ErrorBoundary';
import { LanguageProvider } from './i18n/LanguageContext';
import { ConfirmD10SProvider } from './context/ConfirmD10SContext';
import './App.css';
import './styles/polygonal-design.css';
import './styles/navbar-gaming.css';
import './styles/home-gaming-new.css';
import './styles/marketplace-gaming.css';
import './styles/tournaments-gaming.css';
import './styles/rankings-gaming.css';
import './styles/profile-gaming.css';
import './styles/deposit-gaming.css';
import './styles/formation-gaming.css';
import './styles/rules-page.css';
import './styles/tournament-entry-gaming.css';
import './styles/auth-gaming.css';
import './styles/admin-gaming.css';
import './styles/mobile-optimizations.css';
import './styles/cookie-gdpr.css';

// Componente per gestire la visibilità del Navbar
const AppContent = () => {
  const location = useLocation();
  const hideNavbarPaths = ['/login', '/register', '/forgot-password', '/onboarding/language', '/onboarding/pack-opening'];
  const isAdminPath = location.pathname.startsWith('/admin');
  const shouldShowNavbar = !hideNavbarPaths.includes(location.pathname) && !isAdminPath;
  const shouldShowSupport = !hideNavbarPaths.includes(location.pathname) && !isAdminPath;
  const shouldShowFooter = !isAdminPath;
  const contentClassName = shouldShowNavbar ? 'app-content app-content-offset' : 'app-content';

  return (
      <div className="App min-h-screen">
      {/* Navbar renderizzato UNA SOLA VOLTA, condizionalmente */}
      {shouldShowNavbar && <Navbar />}
      {shouldShowSupport && <SupportWidget />}
      <CookieBanner />
      <CookiePreferencesModal />
            
            {/* User Routes */}
            <div className={contentClassName}>
              <Routes>
            <Route path="/admin/*" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="users/:id" element={<AdminUserDetail />} />
              <Route path="admins" element={<AdminAdmins />} />
              <Route path="gameweeks" element={<AdminGameWeeks />} />
              <Route path="gameweeks/:id" element={<AdminGameWeekDetail />} />
              <Route path="tournaments/:id" element={<AdminTournamentDetail />} />
              <Route path="scores" element={<AdminScores />} />
              <Route path="monthly-rankings" element={<AdminMonthlyRankings />} />
              <Route path="mondiali" element={<AdminMondiali />} />
              <Route path="secondary-market" element={<AdminSecondaryMarket />} />
              <Route path="cards" element={<AdminCards />} />
              <Route path="coach-cards" element={<AdminCoachCards />} />
              <Route path="packs" element={<AdminPacks />} />
              <Route path="economy" element={<AdminEconomy />} />
              <Route path="marketplace" element={<AdminMarketplace />} />
              <Route path="affiliations" element={<AdminAffiliations />} />
              <Route path="withdrawals" element={<AdminWithdrawals />} />
              <Route path="promo-code" element={<AdminPromoCode />} />
                  <Route path="security-reports" element={<AdminSecurityReports />} />
                  <Route path="communications" element={<AdminCommunications />} />
                  <Route path="platform-email" element={<AdminPlatformEmail />} />
              <Route path="logs" element={<AdminLogs />} />
              <Route path="paypal-deposits" element={<AdminPaypalDeposits />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="settings/players" element={<AdminSettingsPlayers />} />
            </Route>
            <Route path="/*" element={
              <>
                <Routes>
                  {/* Auth Routes - senza Navbar */}
                  <Route path="/register" element={<Register />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  
                  {/* Onboarding Routes */}
                  <Route path="/onboarding/tutorial" element={
                    <main>
                      <Home />
                      <Tutorial />
                    </main>
                  } />
                  <Route path="/onboarding/language" element={<LanguageSelection />} />
                  <Route path="/onboarding/pack-opening" element={<PackOpening />} />
                  
                  {/* Main App Routes - Navbar già renderizzato sopra */}
                  <Route path="/" element={
                    <main>
                      <Home />
                    </main>
                  } />
                  <Route path="/marketplace" element={
                    <main>
                      <Marketplace />
                    </main>
                  } />
                  <Route path="/rankings" element={
                    <main>
                      <Rankings />
                    </main>
                  } />
                  <Route path="/rules/*" element={
                    <main>
                      <RulesPage />
                    </main>
                  } />
                  <Route path="/profile" element={
                    <main>
                      <Profile />
                    </main>
                  } />
                  <Route path="/wallet" element={<Navigate to="/deposit" replace />} />
                  <Route path="/notifications" element={<Navigate to="/profile" replace state={{ openTab: 'notifications' }} />} />
                  <Route path="/deposit" element={
                    <main>
                      <Deposit />
                    </main>
                  } />
                  <Route path="/tournaments" element={
                    <main>
                      <Tournaments />
                    </main>
                  } />
                  <Route path="/tournaments/:id/formation" element={
                    <main>
                      <TournamentFormation />
                    </main>
                  } />
                  <Route path="/tournaments/:id/scores" element={
                    <main>
                      <TournamentFormation viewOnly={true} />
                    </main>
                  } />
                  <Route path="/tournaments/:id/enter" element={
                    <main>
                      <TournamentEntry />
                    </main>
                  } />
                </Routes>
              </>
            } />
              </Routes>
            </div>
      {shouldShowFooter && <GlobalFooter />}
    </div>
  );
};

function App() {
  return (
    <WalletProvider>
      <SoundProvider>
      <MusicProvider>
      <LanguageProvider>
        <ConfirmD10SProvider>
          <CookieConsentProvider>
            <Router>
              <ErrorBoundary>
                <OnboardingGuard>
                  <AppContent />
                </OnboardingGuard>
              </ErrorBoundary>
            </Router>
          </CookieConsentProvider>
        </ConfirmD10SProvider>
      </LanguageProvider>
      </MusicProvider>
      </SoundProvider>
    </WalletProvider>
  );
}

export default App;
